export default {
    url: '',
    template: '<training-company-list />'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/trainingcompanies/list/index.js